

































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'action-bar',
    components: {
        'vnodes': {
            functional: true,
            render: (h: any, ctx: any) => ctx.props.vnodes
        }
    }
})
export default class ActionBar extends Vue
{
    @Prop() private breakpoint: boolean;
    @Prop({default: false}) private autoHeader: boolean;
    @Prop({default: false}) private toggleFooter: boolean;
    @Prop({default: false}) private toggleHeader: boolean;
    @Prop() private headerTitle: string;
    @Prop() private headerIcon: string;

    private dropdown: boolean = false;
    private floating: boolean = false;

    created()
    {
        this.onBreakpointChanged(this.condition);
    }

    private get condition()
    {
        if (this.breakpoint !== undefined)
            return this.breakpoint;
        else
            return this.mobile;
    }

    private all(): any[]
    {
        return this.$slots.default.filter((p: any) => p.componentOptions && p.componentOptions.tag == 'action-button');
    }

    private toolbar(): any[]
    {
        return this.all().filter((p: any) => p.componentOptions.propsData.toolbar !== undefined && p.componentOptions.propsData.toolbar !== false);
    }

    private firstToolbar(): any[]
    {
        let toolbar = this.toolbar();

        return toolbar.length > 0 ? [toolbar[0]] : [];
    }

    private otherToolbar(): any[]
    {
        return this.toolbar().slice(1);
    }

    private firstToolbarClass(): string
    {
        return `btn btn-${this.firstToolbar()[0].componentOptions.propsData.variant}`;
    }

    private back(): any[]
    {
        return this.all().filter((p: any) => p.componentOptions.propsData.back !== undefined && p.componentOptions.propsData.back !== false);
    }

    private firstBack(): any[]
    {
        let back = this.back();

        return back.length > 0 ? [back[0]] : [];
    }

    private other(): any[]
    {
        let toolbar = this.toolbar();
        let back = this.firstBack();

        return this.all().filter(p => !toolbar.includes(p) && !back.includes(p));
    }

    private get card()
    {
        let parent = this.$parent;

        while (parent)
        {
            if (parent.$options.name == 'data-card')
            {
                return parent;
            }

            parent = parent.$parent;
        }

        return null;
    }

    @Watch('condition')
    onBreakpointChanged(value: boolean)
    {
        if ((this.toggleHeader || this.toggleFooter) && this.card)
        {
            let card = this.card as any;

            if (this.toggleHeader)
            {
                if (value == false)
                    card.showHeader();
                else
                    card.hideHeader();
            }
            if (this.toggleFooter)
            {
                if (value == false)
                    card.showFooter();
                else
                    card.hideFooter();
            }
        }
    }
}
